export const queryKeys = {
  auth: {
    all: ['auth'] as const,
    user: () => [...queryKeys.auth.all, 'user'] as const,
  },
  patients: {
    all: ['patients'] as const,
    lists: () => [...queryKeys.patients.all, 'list'] as const,
    list: (filters?: Record<string, unknown>) => [...queryKeys.patients.lists(), filters] as const,
    details: () => [...queryKeys.patients.all, 'detail'] as const,
    detail: (id: string) => [...queryKeys.patients.details(), id] as const,
    create: () => [...queryKeys.patients.all, 'create'] as const,
    update: (id: string) => [...queryKeys.patients.all, 'update', id] as const,
    delete: (id: string) => [...queryKeys.patients.all, 'delete', id] as const,
    uploadDocument: (id: string) => [...queryKeys.patients.all, 'uploadDocument', id] as const,
  },
  staff: {
    all: ['staff'] as const,
    lists: () => [...queryKeys.staff.all, 'list'] as const,
    list: (filters?: Record<string, unknown>) => [...queryKeys.staff.lists(), filters] as const,
    details: () => [...queryKeys.staff.all, 'detail'] as const,
    detail: (id: string) => [...queryKeys.staff.details(), id] as const,
  },
  documents: {
    all: ['documents'] as const,
    lists: () => [...queryKeys.documents.all, 'list'] as const,
    list: (filters?: Record<string, unknown>) => [...queryKeys.documents.lists(), filters] as const,
    details: () => [...queryKeys.documents.all, 'detail'] as const,
    detail: (id: string) => [...queryKeys.documents.details(), id] as const,
    byPatient: (patientId: string) => [...queryKeys.documents.all, 'patient', patientId] as const,
    byStaff: (staffId: string) => [...queryKeys.documents.all, 'staff', staffId] as const,
  },
  financials: {
    all: ['financials'] as const,
    lists: () => [...queryKeys.financials.all, 'list'] as const,
    list: (filters?: Record<string, unknown>) =>
      [...queryKeys.financials.lists(), filters] as const,
    details: () => [...queryKeys.financials.all, 'detail'] as const,
    detail: (id: string) => [...queryKeys.financials.details(), id] as const,
    summary: (period?: string) => [...queryKeys.financials.all, 'summary', period] as const,
  },
  chat: {
    all: ['chat'] as const,
    status: () => [...queryKeys.chat.all, 'status'] as const,
    conversations: () => [...queryKeys.chat.all, 'conversations'] as const,
    conversation: (id: string) => [...queryKeys.chat.all, 'conversation', id] as const,
    messages: (conversationId: string) =>
      [...queryKeys.chat.all, 'messages', conversationId] as const,
  },
  dashboard: {
    all: ['dashboard'] as const,
    stats: () => [...queryKeys.dashboard.all, 'stats'] as const,
  },
  facility: {
    all: ['facility'] as const,
    current: () => [...queryKeys.facility.all, 'current'] as const,
    users: () => [...queryKeys.facility.all, 'users'] as const,
    teamMembers: () => [...queryKeys.facility.all, 'team'] as const,
  },
  generatedDocuments: {
    all: ['generatedDocuments'] as const,
    lists: () => [...queryKeys.generatedDocuments.all, 'list'] as const,
    list: (filters?: Record<string, unknown>) =>
      [...queryKeys.generatedDocuments.lists(), filters] as const,
    byPatient: (patientId: string) =>
      [...queryKeys.generatedDocuments.all, 'patient', patientId] as const,
    readiness: (patientId: string) =>
      [...queryKeys.generatedDocuments.all, 'readiness', patientId] as const,
  },
  schedule: {
    all: ['schedule'] as const,
    shifts: (params?: Record<string, unknown>) =>
      [...queryKeys.schedule.all, 'shifts', params] as const,
    templates: () => [...queryKeys.schedule.all, 'templates'] as const,
  },
} as const
